export default "__VITE_PUBLIC_ASSET__43dc8546__"